import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { fetchDeviceData, fetchEvents, fetchDeviceLogs, clearDevice } from '#action/device/overview';
import { fetchLocations } from '#action/device/locations';
import { fetchMetricsByIdentifier, clearMetrics } from '#action/device/measurements';
import { fetchMeta } from '#action/meta/device';
import useWidth from '#hooks/useWidth';
import DeviceOverview from './overview';

// TODO: Remove classes prop when component/map module is migrated to MUI system
const createClasses = theme => ({
  map: theme.mixins?.map || {}
});

function WidthWrapper(props) {
  const width = useWidth();
  const theme = useTheme();
  const classes = useMemo(() => createClasses(theme), [theme]);

  return <DeviceOverview {...props} width={width} theme={theme} classes={classes} />;
}

function mapStateToProps(state) {
  const { device, metrics, dispatch, account, locations, meta } = state;

  return {
    device,
    metrics,
    dispatch,
    account,
    locations,
    meta
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    fetchDevice: ids =>
      dispatch(fetchDeviceData(ids)),
    fetchEvents: (ids, period) =>
      dispatch(fetchEvents(ids, period)),
    fetchDeviceLogs: (ids, period) =>
      dispatch(fetchDeviceLogs(ids, period)),
    fetchMetricsByIdentifier: (ids, period, identifier) =>
      dispatch(fetchMetricsByIdentifier(ids, period, identifier)),
    clearMetrics: () => dispatch(clearMetrics()),
    fetchLocations: (ids, period) =>
      dispatch(fetchLocations(ids, period)),
    fetchMeta: () => dispatch(fetchMeta()),
    clearDevice: () => dispatch(clearDevice())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WidthWrapper);
